/* tslint:disable */
/* eslint-disable */
/**
 * ELOfleet API Documentation
 * Backend of the ELOfleet fleet management system
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface VehicleTypeUpdate
 */
export interface VehicleTypeUpdate {
    /**
     * 
     * @type {string}
     * @memberof VehicleTypeUpdate
     */
    label?: string | null;
}

/**
 * Check if a given object implements the VehicleTypeUpdate interface.
 */
export function instanceOfVehicleTypeUpdate(value: object): value is VehicleTypeUpdate {
    return true;
}

export function VehicleTypeUpdateFromJSON(json: any): VehicleTypeUpdate {
    return VehicleTypeUpdateFromJSONTyped(json, false);
}

export function VehicleTypeUpdateFromJSONTyped(json: any, ignoreDiscriminator: boolean): VehicleTypeUpdate {
    if (json == null) {
        return json;
    }
    return {
        
        'label': json['label'] == null ? undefined : json['label'],
    };
}

export function VehicleTypeUpdateToJSON(json: any): VehicleTypeUpdate {
    return VehicleTypeUpdateToJSONTyped(json, false);
}

export function VehicleTypeUpdateToJSONTyped(value?: VehicleTypeUpdate | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'label': value['label'],
    };
}

